/**
 * API service constants
 */
export const API_CONSTANTS = {
  AUTH_BASE_URL:
    import.meta.env.VITE_AUTH_API_URL || 'https://dev-id.jsitedu.id/api/v1',
  CORE_BASE_URL:
    import.meta.env.VITE_CORE_API_URL || 'https://dev-api.jsitedu.id/api/v1',
  PUBLIC_BASE_URL:
    import.meta.env.VITE_PUBLIC_API_URL ||
    'https://dev-api.jsitedu.id/public/api/v1',
  SERVICES: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout'
    },
    USER: {
      PROFILE: '/users/profile',
      LIST: '/users/list',
      DELETE_BULK: '/users/delete-bulk'
    }
  }
}
